import { Message } from 'element-ui';

const $toast = {
  info (val) {
    Message({
      message: val,
    });
  },
  success (val) {
    Message.success(val);
  },
  warning (val) {
    Message.warning(val);
  },
  error (val) {
    Message.error(val);
  },
};

export default $toast;
